/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import i18next from 'i18next';
import { twoDecimalsFormatter } from '../../../shared/utils/stringUtils';

/**
 * Computes the total of selected (enabled) fee rows.
 *
 * @param selectedFees - array with the fee rows selected for payment
 * @param feesSelection - the uiSchema feesSelection object
 * @returns total of fees (considering also disabled rows)
 */
export const computeTotalSelectedFees = (selectedFees, feesSelection) => {
  return selectedFees?.reduce((accumulator, fee) => {
    const feeDefinition = feesSelection?.values?.find(feeDefinitionEntry => feeDefinitionEntry.code === fee.code);
    const sumToAdd = feeDefinition?.disabled && !feeDefinition?.readOnly ? 0 : fee.subtotal;
    const total = sumToAdd ? accumulator + sumToAdd : accumulator;
    return Number(total.toFixed(2));
  }, 0);
};

/**
 * Extracts the typeOfProtection field into a wrapper object if the field has value.
 * @param submission
 * @returns false or { typeOfProtection: * }
 */
export const getTypeOfProtectionField = (submission) => {
  const typeOfProtection = submission?.basicFilingInfo?.typeOfProtection;
  return typeOfProtection && { typeOfProtection };
};

/**
 * Amount formatter used for fees
 */
export const amountFormatter = () => twoDecimalsFormatter(i18next.language);

/**
 * Retrieves the fee description by code from the feesSelection array.
 *
 * @deprecated Deprecated, use {@link useFees#getFeeAdditionalConfig}.descriptionKey instead
 */
export const getFeeDescriptionByFeeCode = (feesSelection, code) => {
  const fee = feesSelection?.filter(item => item?.code === code);
  return fee?.length > 0 ? fee[0].text : '';
};
